//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Add
import Cropper from 'react-easy-crop'
import { imageResize } from '../func/imageResizeRotate';
import getCroppedImg from '../func/imageCrop';
//Material-ui
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Slider from '@material-ui/core/Slider'

//Icon
import CloseIcon from '@material-ui/icons/Close';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import RotateRightIcon from '@material-ui/icons/RotateRight';

import CropSquareIcon from '@material-ui/icons/CropSquare';
import CropLandscapeIcon from '@material-ui/icons/CropLandscape';
import CropPortraitIcon from '@material-ui/icons/CropPortrait';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      thumbImage: null,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      if (this.props.originImage) {
        this._imageLoad(this.props.originImage);
        this.setState({
          zoom: 1,
          aspect: 1,
          rotation: 0,
          crop: {
            x: 0,
            y: 0,
          },
          croppedAreaPixels: {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
          }
        });
      }
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 3000).then((res) => {
      this.setState({thumbImage:res.uri});
    }).catch((err) => {
      this.setState({thumbImage:null});
    })
  }


  async _submit() {
    try {
      const croppedImage = await getCroppedImg(
        this.state.thumbImage,
        this.state.croppedAreaPixels,
        this.state.rotation
      )
      this.props.onSubmit(croppedImage);
      this.props.close();
    } catch (e) {
      console.error(e)
    }
  }

  _cropChange(value) {
    this.setState({
      crop: value
    })
  }

  _zoomChange(value) {
    this.setState({
      zoom: value
    })
  }

  _rotationChange(value) {
    this.setState({
      rotation: value
    })
  }

  _cropComplete(croppedAreaPixels) {
    this.setState({
      croppedAreaPixels: croppedAreaPixels
    })
  }

	render() {
		return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={ () => this.props.close() }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
      >
        <div
          style={{
            background:'#FFF',
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
            zIndex:'10000',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            写真の編集
          </div>
          <IconButton
            onClick={ () => {
              this.props.close();
            }}
          >
            <CloseIcon/>
          </IconButton>
        </div>

        <div style={{height:'60vh',position:'relative',}}>
          {
            (this.state.thumbImage) && (
              <Cropper
                image={this.state.thumbImage}
                aspect={this.state.aspect}
                crop={this.state.crop}
                zoom={this.state.zoom}
                rotation={this.state.rotation}
                onCropChange={ (v) => this._cropChange(v) }
                onZoomChange={ (v) => this._zoomChange(v) }
                onRotationChange={ (v) => this._rotationChange(v) }
                onCropComplete={ (croppedArea, croppedAreaPixels) => this._cropComplete(croppedAreaPixels) }
              />
            )
          }
        </div>
        <div style={{margin:'20px'}}>

          <div>
            <ButtonGroup color="primary">
              <Button
                variant={this.state.aspect === 1 ? "contained" : "outlined"}
                onClick={ (e) => this.setState({aspect: 1 }) }
              >
                <CropSquareIcon />
              </Button>
              <Button
                variant={this.state.aspect === 1.3333333333333333 ? "contained" : "outlined"}
                onClick={ (e) => this.setState({aspect: 1.3333333333333333 }) }
              >
                <CropLandscapeIcon />
              </Button>
              <Button
                variant={this.state.aspect === 0.75 ? "contained" : "outlined"}
                onClick={ (e) => this.setState({aspect: 0.75 }) }
              >
                <CropPortraitIcon />
              </Button>
            </ButtonGroup>
          </div>

          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              marginTop:'10px'
            }}
          >
            <ZoomOutMapIcon style={{color:'#666', marginRight:'10px'}} />
            <Slider
              value={this.state.zoom}
              min={1}
              max={3}
              step={0.1}
              onChange={ (e, value) => this.setState({zoom: value}) }
            />
          </div>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
            }}
          >
            <RotateRightIcon style={{color:'#666', marginRight:'10px'}} />
            <Slider
              value={this.state.rotation}
              min={0}
              max={360}
              step={5}
              onChange={ (e, value) => this.setState({rotation: value}) }
            />
          </div>

          <div style={{margin:'10px'}} align='center'>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'160px'}}
              onClick={ () => this._submit() }
            >
              <span style={{fontSize:'1.4em'}}>切り抜く</span>
            </Button>
          </div>
        </div>

			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
